<div class="ai-button-tab-wrapper">
    <button
        (click)="onClick(option)"
        [ngClass]="{
            'ai-button': true,
            'ai-button-with-label': true,
            'ai-button-tab': true,
            'ai-is-active': option.value === selected()?.value,
        }"
        *ngFor="let option of options()"
    >
        @if (option.icon) {
            <ai-icon [fontIcon]="option.icon" />
        }
        {{ option.label }}
    </button>
</div>
